import {
  ExpertRewardsConfiguration,
  REWARDS_INVITATION_STATUS
} from "@arbolus-technologies/models/common";

export const MINIMUM_REVIEWS_FOR_REWARDS = 5;
export const DEFAULT_QUANTITATIVE_COMPENSATION = 1;
export const DEFAULT_QUALITATIVE_COMPENSATION = 5;
export const DEFAULT_MINIMUM_CLAIM_AMOUNT = 100;
export const DEFAULT_NEW_JOINER_COMPENSATION = 10;
export const DEFAULT_REFERRAL_COMPENSATION = 10;
export const DEFAULT_MAX_REFERRAL_EARNINGS_PER_EXPERT = 5;
export const DEFAULT_REWARDS_ISO_CURRENCY_CODE = "USD";

// Fallback used while the rewards configuration endpoint loads or if it is
// unavailable, so the rewards UI always has sensible values to display.
export const DEFAULT_REWARDS_CONFIGURATION: ExpertRewardsConfiguration = {
  minimumRequiredInsights: MINIMUM_REVIEWS_FOR_REWARDS,
  quantitativeCompensation: DEFAULT_QUANTITATIVE_COMPENSATION,
  qualitativeCompensation: DEFAULT_QUALITATIVE_COMPENSATION,
  minimumClaimAmount: DEFAULT_MINIMUM_CLAIM_AMOUNT,
  newJoinerCompensation: DEFAULT_NEW_JOINER_COMPENSATION,
  newJoinerIsoCurrencyCode: DEFAULT_REWARDS_ISO_CURRENCY_CODE,
  maxReferralEarningsPerExpert: DEFAULT_MAX_REFERRAL_EARNINGS_PER_EXPERT,
  referralCompensation: DEFAULT_REFERRAL_COMPENSATION,
  referralIsoCurrencyCode: DEFAULT_REWARDS_ISO_CURRENCY_CODE
};

export const REWARDS_INVITATION_STATUS_STEP: Record<
  REWARDS_INVITATION_STATUS,
  number
> = {
  [REWARDS_INVITATION_STATUS.SENT]: 1,
  [REWARDS_INVITATION_STATUS.SOFTWARE_REVIEWS_PENDING]: 2,
  [REWARDS_INVITATION_STATUS.SOFTWARE_REVIEWS_SUBMITTED]: 3,
  [REWARDS_INVITATION_STATUS.JOINED]: 4
};

export const REWARDS_INVITATION_TOTAL_STEPS = Object.keys(
  REWARDS_INVITATION_STATUS_STEP
).length;

export const REWARDS_INVITATION_STATUS_LABEL_KEY: Record<
  REWARDS_INVITATION_STATUS,
  string
> = {
  [REWARDS_INVITATION_STATUS.SENT]: "rewards:referrals.statusSent",
  [REWARDS_INVITATION_STATUS.SOFTWARE_REVIEWS_PENDING]:
    "rewards:referrals.statusSoftwareReviewsPending",
  [REWARDS_INVITATION_STATUS.SOFTWARE_REVIEWS_SUBMITTED]:
    "rewards:referrals.statusSoftwareReviewsSubmitted",
  [REWARDS_INVITATION_STATUS.JOINED]: "rewards:referrals.statusJoined"
};
